import { TFunction } from 'i18next';
import parsePhoneNumberFromString from 'libphonenumber-js';
import * as yup from 'yup';

export const signInValidationSchema = (
  t: TFunction<'translation', undefined>,
) =>
  yup.object({
    phone: yup
      .string()
      .required(t('userAuth.validationErrors.phoneRequired'))
      .test(
        'phone-validators',
        t('userAuth.validationErrors.invalidPhoneNumber'),
        function (value) {
          if (!value || value === '') return false;
          const phoneNumber = parsePhoneNumberFromString(value, 'UA');
          return phoneNumber?.isValid() || false;
        },
      ),
  });
